@use '@design/design-tokens/typography/typography' as *;

@layer design-system {
  .container {
    width: 100%;
    height: 100%;
  }

  .text {
    @include typography-v2-ui-xs;
    color: var(--text-disabled);
    font-family: var(--font-nort);

    &.useDash {
      @include typography-v2-ui-sm;
      color: var(--text-soft);
      font-family: var(--font-roboto);
    }
  }
}
